let GuideView = require("../../templates/GuideView.handlebars");
let $ = require("jquery");
let _ = require("underscore");
let Backbone = require("backbone");
let i18n = require("../../utils/i18n");

let main = function () {
    return Backbone.View.extend({
        intervalProcess: 0,
        initialize: function (options) {
            var self = this;
            if (!self.model) {
                self.model = new Backbone.Model(options);
            }
            self.model.on("change", function (options) {
                if (options) {
                    self.changeEl(options.toJSON());
                }
            });
        },
        events: {
            "click .guideBtn button": "_onClickBtn",
            "click .guideModal button": "_guideEvent",
            'click .survey-modal a': "_selectPanel",
            'click .submit': '_submit',
            "click .guideImage img": "_onClickImg"
        },
        /**
         * @private 关闭guideView
         */
        _close: function () {
            $('#guideView').addClass("hidden");
            $('.mask').siblings(".guide").remove();
        },

        setErrors: function (errorCode) {
            if ($('form').length > 0) {
                $('form .email').siblings('.help-block').text(i18n.msg(errorCode));
            }
        },
        _selectPanel: function (evt) {
            var panel = $(evt.currentTarget);
            $('ul li').removeClass('active');
            $('.panel').removeClass('active');
            panel.closest('li').addClass('active');
            if (panel.hasClass('weixin')) {
                $('div.weixin').addClass('active');
                $('div.gb').addClass('hidden');
                $('.guide-foot').show();
                var staffId = $('div.weixin').data('id');
                this._checkWeixinSubScript(staffId)
            } else if (panel.hasClass('emailRegister')) {
                $('div.emailRegister').addClass('active');
                $('div.gb').removeClass('hidden');
                $('.guide-foot').show();
            }
        },
        _checkWeixinSubScript: function (staffId) {
            var self = this;
            console.log("_checkWeixinSubScript");
            if (staffId) {
                $.post("/pos/checkStaffEvent", {staffId: staffId}, function (response) {
                    console.log(response);
                    if (response.success) {
                        self.trigger("subscript");
                    }else{
                        setTimeout(function(){
                            self._checkWeixinSubScript(staffId);
                        },5000);
                    }
                });
            }
        },
        _guideEvent: function (evt) {
            var self = this, email = $('form .email');
            if ($(evt.currentTarget).hasClass("close-modal")) {
                self._close();
            }
            if (email.length > 0 && email.hasClass('.active')) {
                if (email.val().trim().length === 0) {
                    email.siblings('.help-block').text(i18n.msg('pos.guide.email.null'));
                    email.focus();
                    return;
                }
                //this.trigger('submit', {email: email.val(), pwd: pwd.val()});
            }
            self.trigger("clickBtn", {btn: $(evt.currentTarget), email: email.length > 0 ? email.val() : ''});
            return false;
        },
        _closeModal: function () {
            $(".guideModal").hide();
        },
        _showModal: function () {
            $(".guideModal").show();
        },
        _closeGuide: function (el) {
            $(".guideImage").addClass("hidden");
        },
        _showGuide: function () {
            $(".guideImage").removeClass("hidden");
        },
        /**
         * @private 响应按钮事件
         */
        _onClickBtn: function (evt) {
            var self = this;
            self._close();
            if (!$(evt.currentTarget).hasClass("close-modal")) {
                self.trigger("clickBtn", {btn: $(evt.currentTarget)});
            }
            return false;
        },
        /**
         * @private 响应点击事件
         */
        _onClickImg: function (evt) {
            var self = this;
            self._close();
            self.trigger("clickImg", {img: $(evt.currentTarget)});
            return false;
        },
        /**
         * @private 改变guideview里的内容
         */
        changeEl: function (options) {
            var self = this, el, gView = $("#guideView");
            el = $(GuideView(options));
            el.find(".guideModal").hide();
            el.find(".guidelogo").addClass("hidden");
            if (options.welcome) {
                el.find(".guideText").after(options.welcome);
                delete options.welcome;
            }
            if (options.guideImage) {
                el.find(".guideText").after(options.guideImage);
                delete options.guideImage;
            }
            if (options.guideBtn) {
                el.find(".guideBtn").empty().append(options.guideBtn);
                delete options.guideBtn;
            }
            if (options.guideModal) {
                el.find(".guideModal").show();
                el.find(".guideModal .guide-body").empty().append(options.guideModal);
                delete options.guideModal;
            }
            if (options.guideFoot) {
                el.find(".guide-foot").empty().append(options.guideFoot);
                delete options.guideFoot;
            }
            if (options.guideText) {
                el.find(".guidelogo").removeClass("hidden");
                el.find(".guidelogo").after(options.guideText);
                delete options.guideText;
            }
            if (gView.find(".guide")) {
                $('.mask').siblings(".guide").remove();
            }
            gView.append(el);
            if (options.guideStatus) {
                self._closeGuide();
                delete options.guideStatus;
            }
            self.setElement(el);
            if (gView.hasClass("hidden")) {
                gView.removeClass("hidden");
            }
        }
    });
};

let exportedValue = main();
module.exports = exportedValue;


// WEBPACK FOOTER //
// ./src/view/comp/GuideView.js